import React,{useState, useEffect} from 'react'
import { Container, Row, Col} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import HeaderBlack from '../component/Header/HeaderBlack';
import Footer from '../component/Header/Footer';

function HomeBlack()
{
    const [isVisible, setIsVisible] = useState(true);

      const images = [
    'https://wolfed.b-cdn.net/modernappforce/modern-appforce-main-screen-one.png',
    'https://wolfed.b-cdn.net/modernappforce/modern-appforce-main-screen-two.png',
    'https://wolfed.b-cdn.net/modernappforce/modern-appforce-main-screen-three.png',
  ];

  const interval = 1500; // time in milliseconds
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, interval);

    return () => clearInterval(timer); // Cleanup on unmount
  }, [images.length]);

return(
<>
<HeaderBlack/>
<div id="home" className="bioly-pf-hero-main-content">
{isVisible && (
        <div className="fcl-content-note">
            <div className="fcl-close-icon" onClick={() => setIsVisible(false)}><i class="fa fa-window-close-o" aria-hidden="true"></i></div>
            <ul className="fcl-content-list">
                <li><i class="fa fa-check-square-o"></i> Modern AppForce player does not sell playlists or subscriptions.</li>
                <li><i class="fa fa-check-square-o"></i> Please be advised that there are no refunds after purchase.</li>
                <li><i class="fa fa-check-square-o"></i> It is a video media player and does not offer channels or include any content. Please note, Modern AppForce player is not responsible for the content utilized within our app.</li>
                <li><i class="fa fa-check-square-o"></i> The app offers a 3-day trial period for testing purposes. After this period, a license must be purchased to continue using the app.
                </li>
            </ul>
        </div>
         )}
  <img src="https://wolfed.b-cdn.net/modernappforce/Modern-app-top-banner.jpg" alt="best android tv in europe"/>
  <div class="app-pro-hero-section-absolute">
  <Container>
    <Row>
      <Col xxl={6} xl={6} lg={6} md={6} sm={12}>
        <div className="bioly-pf-hero-sections">
         <h1 className="wow fadeInDown" data-wow-duration="2s">All-Day,Every-Day <span className="fclassic-color">Entertainment</span></h1>
         <p className="wow fadeInUp" data-wow-duration="2s"><a href="https://appforceclassic.com/install-appforce-classic">Best media player application</a>, available for Android TV and Firestick</p>
         <span style={{fontSize:"14px",color:"#ffffff",position:"relative",top:"-10px",fontWeight:"700"}} className="wow fadeInDown" data-wow-duration="2s">(Note: Modern Appforce is not for Android Mobile)</span>
         <div className="mod-mobile-serie-object">
            <img src="https://wolfed.b-cdn.net/modernappforce/modern-series.png" alt="modern series"/>
         </div>
        </div>
      </Col>
    </Row>
  </Container>
  </div>
</div>


<section id="app-pro-about-section">
    <div className="app-pro-about-object">
        <img src="https://wolfed.b-cdn.net/modernappforce/modern-about.jpg" class="about-desktop" alt="Modern Appforce about"/>
        <img src="https://wolfed.b-cdn.net/modernappforce/modern-appforce-about.jpg" class="about-mobile" alt="Modern Appforce about"/>
    </div>
    <div data-wow-duration="2s" className="app-pro-about-content animate__animated animate__zoomInUp">
        <h2>Stream Smoothly with the<br/> Sounds You Love</h2>
        <p><span className="fcls-text">Modern AppForce </span>is a powerful and intuitive media player designed to elevate your viewing experience. Simply add a playlist from your preferred service provider to get started and enjoy nonstop entertainment tailored to you.</p>
    </div>
</section>

<section id="mod-ref-section">
    <div className="container">
        <div className="row pdm-5">
            <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="wow fadeInLeft mod-ref-heading">
                     <span>Refersh</span>
                     <h2>Stay Updated with a Single Tap</h2>
                     <p>Want to see the latest content? Just tap the Refresh button on your screen to instantly reload and update everything. It’s quick, simple, and keeps your experience up to date without any hassle.</p>
                </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="mod-ref-object">
                    <img src="https://wolfed.b-cdn.net/modernappforce/Refreshes.png" alt="refersh"/>
                </div>
            </div>
        </div>    

        <div className="row row-mod-setting pdm-5">
            <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="mod-setting-object">
                    <img src="https://wolfed.b-cdn.net/modernappforce/Seting.png" alt="refersh"/>
                </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="mod-setting-heading wow fadeInRight">
                     <span>Setting</span>
                     <h2>Control Your Experience Easily</h2>
                     <p>Need to adjust your preferences? Just tap the Settings button on your screen to access the full settings menu. From there, you can customize your experience the way you like it—quick and hassle-free.</p>
                </div>
            </div>

        </div>

        <div className="row pdm-5">
            <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="mod-wifi-heading wow fadeInLeft">
                     <span>Network Setting</span>
                     <h2>Stay Connected, Always</h2>
                     <p>Having trouble with your connection or switching networks? Just tap the Network Settings button to check your current status, connect to Wi-Fi, or troubleshoot in seconds. A stable connection is just a tap away!</p>
                </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="mod-wifi-object">
                    <img src="https://wolfed.b-cdn.net/modernappforce/network-setting.png" alt="refersh"/>
                </div>
            </div>

        </div>
    </div>
</section>

<section id="mod-series-section">
    <div className="container">
        <div data-wow-duration="2s" className="mod-design-content  animate__animated animate__zoomInDown">
            <h2>Upgrade Your Viewing Experience<br/> with Sleek Design</h2>
        <p>Our movie section features a clean, modern look tailored for a premium experience. With just one tap, you can customize your screen layout and enjoy a visually stunning interface that matches your style.</p>
        </div>
        <div className="mod-series-content">
            <img src={images[currentIndex]}
            alt={`slide-${currentIndex}`}
            style={{
                width: '100%',
                height: 'auto',
                objectFit: 'cover',
                transition: 'opacity 0.8s ease-in-out',
            }}
            />
        </div>
    </div>
</section>

<section id="immersiveEntertainment">
    <div className="container">
        <div className="row">
          <div className="immersiveEntertainment-heading">
              <h2>Step into a Seamless World of Live Entertainment Delivered on a Smart, Effortless Interface</h2>
              <p>Transform your live entertainment experience with <span className="fcls-text">Modern Appforce</span> smart, user-friendly interface. Connect with your service provider today and enjoy your handpicked playlists anytime. Start exploring a limitless entertainment journey with Modern Appforce now!</p>
              <Link to="/install-modern-appforce" className="btn btn-getquote">Get A Quote</Link>
          </div>
        </div>
    </div>
</section>


<section id="app-pro-about-section">
    <div className="app-pro-about-object">
        <img src="https://wolfed.b-cdn.net/modernappforce/modernsetting.jpg" className="about-desktop" alt="Modern Appforce qr code"/>
        <img src="https://wolfed.b-cdn.net/modernappforce/qr-code-modern-setting.jpg" className="about-mobile" alt="best Modern Appforce qr code"/>
    </div>
    <div className="app-pro-qrcode wow fadeInDown">
        <h2 className="wow fadeInDown">Enjoy Your Favorite Shows by Adding Playlist<br/> with QR Code Function</h2>
        <p className="wow fadeInUp">Now you do not have to type lengthy URLs to access TV shows and Movies, just use QR code option to add the playlist ebay using your mobile. This option allows you to reach uninterrupted entertainment effortlessly. Have fun with Modern Appforce.</p>
    </div>
</section>

<section id="app-classic-audio-language">
   <div className="container">
    <div className="app-classic-language">
        <h2 className="wow fadeInUp">A Multifaceted App with Features<br/><span className="fclassic-color"> That Fit Your Lifestyle</span></h2>
        <ul>
          <li className="wow fadeInLeft">Set your preferred audio and subtitle languages<br/> just once and enjoy them every time you stream.</li>
          <li className="wow fadeInLeft">No need to reset your language settings with every use.</li>
          <li className="wow fadeInLeft">Adjust the screen’s aspect ratio to match your viewing comfort.</li>
          <li className="wow fadeInLeft">Use the Quick Utilities feature to easily personalize<br/> app settings to your liking.</li>
        </ul>
    </div>
   </div> 
</section>

<section id="app-classic-language-section">
    <div className="app-pro-about-object">
        <img src="https://wolfed.b-cdn.net/modernappforce/multi-language.jpg" className="about-desktop" alt="Modern Appforce multi language"/>
        <img src="https://wolfed.b-cdn.net/modernappforce/modern-appforce-multi-language.jpg" className="about-mobile"  alt="Modern Appforce language"/>        
    </div>
    <div className="app-pro-language animate__animated animate__zoomInDown">
        <h2>Multi language Supported App</h2>
        <p>Modern AppForce offers a wide range of languages, keeping your comfort and convenience in mind. Choose the language you’re most familiar with for a seamless experience.
Enjoy content the way it’s meant to be clear, accessible, and in your own language.</p>
    </div>
</section>


<section id="app-classic-versatile-section">
  <div className="container">
      <div className="app-classic-versatile-content wow fadeInLeft">
        <h2>Flexible Interface<br/> Designed for You</h2>
        <p><span className="fcls-text">Modern Appforce</span> makes watching Live TV a breeze with its intuitive and versatile layout. Choose the interface style that suits you best and enjoy a smooth, personalized viewing experience every time.</p>
      </div>
  </div>
</section>
<div className="versatile-object">
  <img src="https://wolfed.b-cdn.net/modernappforce/Redesigned-with-You-in-mind%20(1).jpg" alt="best media player in germany"/>
</div>


<section id="app-classic-parental-section">
    <div className="app-pro-about-object">
        <img src="https://wolfed.b-cdn.net/modernappforce/modern-parental-conteol.jpg" className="about-desktop" alt="Modern Appforce parental password"/>
        <img src="https://wolfed.b-cdn.net/modernappforce/modern-appforce-parental-control.jpg" className="about-mobile" alt="Modern Appforce parental"/>
    </div>
    <div className="app-pro-parental-control animate__animated animate__zoomInLeft">
        <h2>Secure Selective Content with<br/> Parental Controls</h2>
        <p>Looking to restrict access to certain playlists for kids or other family members? Easily set a Parental Control password to lock specific content and ensure only the right eyes see what’s meant for them.</p>
    </div>
</section>

<section id="appClassic-service-provider">
  <div className="container">
       <div className="row">
          <div className="col-lg-6">
            <div className="appClassic-connect wow fadeInLeft">
              <h2 className="wow fadeInLeft">Simple & Flexible Connection to<br/><span className="fclassic-color"> Your Service Provider</span></h2>
              <p className="wow fadeInUp">Modern AppForce makes it easy to connect with your service provider using Portal, <span className="fclassic-color"><strong>M3U Xtream, M3U Playlist,</strong></span> or Playlist Upload options. 
              <br/>
              Enter URLs quickly with the smart keyboard or scan a QR code from your mobile for instant setup—no hassle, just seamless access.</p>
            </div>
          </div>
          <div className="col-lg-6"></div>
       </div>
  </div>
</section>

<section id="app-classic-password-section">
    <div className="app-pro-about-object">
        <img src="https://wolfed.b-cdn.net/modernappforce/modern-appforce-password.jpg" className="about-desktop" alt="Modern Appforce password"/>
        <img src="https://wolfed.b-cdn.net/modernappforce/best-modern-appforce-password.jpg" className="about-mobile" alt="Modern Appforce password control"/>
    </div>
    <div className="app-pro-password  animate__animated animate__zoomInRight">
        <h2>Keep Your App Secure with Password Protection</h2>
        <p>Modern AppForce lets you set an app-level password to safeguard your content. Control access, manage authorization, and ensure only trusted users can view what's inside. It's a simple way to keep your streaming experience private and family-friendly.</p>
    </div>
</section>
<Footer/>

</>
);
}
export default HomeBlack;